module.exports = __webpack_public_path__ + "static/media/IMG_20240809_175552.9024ad9e.jpg";